export const dublins = [
  {
    ll_id: "bad639e9-29ae-4dee-b57c-4e7c6824848a",
    ll_name: "The Accommodation King",
    ru_id: "384545",
    verified: "yes",
    city: "dublin",
    neigbourhood: "clontarf, east wall and fairview",
    ll_engagement: "medium",
    property_type: "studio",
    rooms: "0",
    price: "1350",
    price_vs_Market: "-1050",
    available_from: "12/21/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/384545",
  },
  {
    ll_id: "bad639e9-29ae-4dee-b57c-4e7c6824848a",
    ll_name: "The Accommodation King",
    ru_id: "384542",
    verified: "yes",
    city: "dublin",
    neigbourhood: "clontarf, east wall and fairview",
    ll_engagement: "medium",
    property_type: "studio",
    rooms: "0",
    price: "1350",
    price_vs_Market: "-1050",
    available_from: "11/24/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/384542",
  },
  {
    ll_id: "bad639e9-29ae-4dee-b57c-4e7c6824848a",
    ll_name: "The Accommodation King",
    ru_id: "384546",
    verified: "yes",
    city: "dublin",
    neigbourhood: "clontarf, east wall and fairview",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "1",
    price: "1650",
    price_vs_Market: "-630",
    available_from: "11/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/384546",
  },
  {
    ll_id: "9bf2dc02-b106-4bc2-a0cb-989ebd820abc",
    ll_name: "My Dublin Space",
    ru_id: "294247",
    verified: "yes",
    city: "dublin",
    neigbourhood: "cabra, phibsborough and smithfield",
    ll_engagement: "medium",
    property_type: "room_shared",
    rooms: "8",
    price: "628",
    price_vs_Market: "-572",
    available_from: "10/9/21",
    admin_fee_type: "fixed",
    admin_fee_value: "50",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/294247",
  },
  {
    ll_id: "f4b781d8-77f0-469a-9460-ef5c6a81cafe",
    ll_name: "Viva Ireland",
    ru_id: "341242",
    verified: "no",
    city: "dublin",
    neigbourhood: "the liberties, inchicore and phoenix park",
    ll_engagement: "medium",
    property_type: "room_shared",
    rooms: "2",
    price: "660",
    price_vs_Market: "-540",
    available_from: "12/19/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/341242",
  },
  {
    ll_id: "f4b781d8-77f0-469a-9460-ef5c6a81cafe",
    ll_name: "Viva Ireland",
    ru_id: "474866",
    verified: "yes",
    city: "dublin",
    neigbourhood: "the liberties, inchicore and phoenix park",
    ll_engagement: "medium",
    property_type: "room_shared",
    rooms: "2",
    price: "660",
    price_vs_Market: "-540",
    available_from: "12/19/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/474866",
  },
  {
    ll_id: "f4b781d8-77f0-469a-9460-ef5c6a81cafe",
    ll_name: "Viva Ireland",
    ru_id: "341241",
    verified: "no",
    city: "dublin",
    neigbourhood: "the liberties, inchicore and phoenix park",
    ll_engagement: "medium",
    property_type: "room_shared",
    rooms: "2",
    price: "750",
    price_vs_Market: "-450",
    available_from: "12/19/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/341241",
  },
  {
    ll_id: "88de8b91-1604-447d-8385-bfd72be63ff9",
    ll_name: "Gary Higgins",
    ru_id: "608143",
    verified: "no",
    city: "dublin",
    neigbourhood: "tallaght, firhouse and jobstown",
    ll_engagement: "low",
    property_type: "room_shared",
    rooms: "5",
    price: "600",
    price_vs_Market: "-360",
    available_from: "11/28/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/608143",
  },
  {
    ll_id: "88de8b91-1604-447d-8385-bfd72be63ff9",
    ll_name: "Gary Higgins",
    ru_id: "608142",
    verified: "no",
    city: "dublin",
    neigbourhood: "tallaght, firhouse and jobstown",
    ll_engagement: "low",
    property_type: "room_shared",
    rooms: "5",
    price: "600",
    price_vs_Market: "-360",
    available_from: "10/24/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/608142",
  },
  {
    ll_id: "63954cd2-85d7-4675-8f8d-5634b2fd09a8",
    ll_name: "Dublin city Apartments",
    ru_id: "385884",
    verified: "no",
    city: "dublin",
    neigbourhood: "cabra, phibsborough and smithfield",
    ll_engagement: "low",
    property_type: "apartment",
    rooms: "1",
    price: "1700",
    price_vs_Market: "-300",
    available_from: "12/6/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/385884",
  },
  {
    ll_id: "45e1367c-59ef-4be2-82ea-41f8e89c26aa",
    ll_name: "Josephine O'Keeffe",
    ru_id: "293076",
    verified: "yes",
    city: "dublin",
    neigbourhood: "donnybrook, irishtown and sandymount",
    ll_engagement: "high",
    property_type: "room_shared",
    rooms: "5",
    price: "895",
    price_vs_Market: "-255",
    available_from: "12/16/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/293076",
  },
  {
    ll_id: "6c39a4a5-531a-4b1b-a9c6-fef9f96f0416",
    ll_name: "Malik Naiz",
    ru_id: "247664",
    verified: "yes",
    city: "dublin",
    neigbourhood: "drumcondra, glasnevin, and santry",
    ll_engagement: "high",
    property_type: "room_shared",
    rooms: "4",
    price: "650",
    price_vs_Market: "-240",
    available_from: "12/19/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/247664",
  },
  {
    ll_id: "63954cd2-85d7-4675-8f8d-5634b2fd09a8",
    ll_name: "Dublin city Apartments",
    ru_id: "335961",
    verified: "yes",
    city: "dublin",
    neigbourhood: "city centre south",
    ll_engagement: "low",
    property_type: "studio",
    rooms: "0",
    price: "1350",
    price_vs_Market: "-230",
    available_from: "11/11/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/335961",
  },
  {
    ll_id: "63954cd2-85d7-4675-8f8d-5634b2fd09a8",
    ll_name: "Dublin city Apartments",
    ru_id: "335962",
    verified: "yes",
    city: "dublin",
    neigbourhood: "city centre south",
    ll_engagement: "low",
    property_type: "studio",
    rooms: "0",
    price: "1350",
    price_vs_Market: "-230",
    available_from: "12/20/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/335962",
  },
  {
    ll_id: "63954cd2-85d7-4675-8f8d-5634b2fd09a8",
    ll_name: "Dublin city Apartments",
    ru_id: "386102",
    verified: "no",
    city: "dublin",
    neigbourhood: "city centre south",
    ll_engagement: "low",
    property_type: "studio",
    rooms: "0",
    price: "1390",
    price_vs_Market: "-190",
    available_from: "12/20/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/386102",
  },
  {
    ll_id: "bad639e9-29ae-4dee-b57c-4e7c6824848a",
    ll_name: "The Accommodation King",
    ru_id: "343798",
    verified: "yes",
    city: "dublin",
    neigbourhood: "drumcondra, glasnevin, and santry",
    ll_engagement: "medium",
    property_type: "apartment",
    rooms: "2",
    price: "2200",
    price_vs_Market: "-180",
    available_from: "9/28/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/343798",
  },
  {
    ll_id: "9bf2dc02-b106-4bc2-a0cb-989ebd820abc",
    ll_name: "My Dublin Space",
    ru_id: "226703",
    verified: "yes",
    city: "dublin",
    neigbourhood: "drumcondra, glasnevin, and santry",
    ll_engagement: "medium",
    property_type: "room_shared",
    rooms: "6",
    price: "628",
    price_vs_Market: "-162",
    available_from: "10/17/21",
    admin_fee_type: "fixed",
    admin_fee_value: "50",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/226703",
  },
  {
    ll_id: "ea30473c-11e1-4708-b7e9-5366dae99d93",
    ll_name: "Duchamp Properties",
    ru_id: "263866",
    verified: "yes",
    city: "dublin",
    neigbourhood: "city centre south",
    ll_engagement: "low",
    property_type: "apartment",
    rooms: "2",
    price: "3800",
    price_vs_Market: "-160",
    available_from: "11/28/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/263866",
  },
  {
    ll_id: "b2e1576e-1e92-4d85-9e3b-269573e356cc",
    ll_name: "Keval Chauhan",
    ru_id: "581879",
    verified: "no",
    city: "dublin",
    neigbourhood: "clondalkin, rowlagh and liffey valley",
    ll_engagement: "low",
    property_type: "room_shared",
    rooms: "1",
    price: "741",
    price_vs_Market: "-159",
    available_from: "11/17/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/581879",
  },
  {
    ll_id: "3eaa0935-5b28-4e09-816e-7dbab2b0d34e",
    ll_name: "terry rochford",
    ru_id: "440719",
    verified: "no",
    city: "dublin",
    neigbourhood: "OTHER_dublin",
    ll_engagement: "low",
    property_type: "room_shared",
    rooms: "4",
    price: "550",
    price_vs_Market: "-150",
    available_from: "10/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/440719",
  },
  {
    ll_id: "5703614c-2bc3-4c15-a6a1-5ed0956d7d77",
    ll_name: "Mihaela Teujhon",
    ru_id: "372496",
    verified: "yes",
    city: "dublin",
    neigbourhood: "OTHER_dublin",
    ll_engagement: "high",
    property_type: "room_shared",
    rooms: "3",
    price: "800",
    price_vs_Market: "-150",
    available_from: "11/2/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/372496",
  },
  {
    ll_id: "c6bb5b37-8766-44ed-b708-d415e7306b4c",
    ll_name: "Daniel DuNoyer",
    ru_id: "265725",
    verified: "yes",
    city: "dublin",
    neigbourhood: "the liberties, inchicore and phoenix park",
    ll_engagement: "high",
    property_type: "apartment",
    rooms: "2",
    price: "3500",
    price_vs_Market: "-150",
    available_from: "10/23/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/265725",
  },
  {
    ll_id: "f4b781d8-77f0-469a-9460-ef5c6a81cafe",
    ll_name: "Viva Ireland",
    ru_id: "341266",
    verified: "no",
    city: "dublin",
    neigbourhood: "cabra, phibsborough and smithfield",
    ll_engagement: "medium",
    property_type: "room_shared",
    rooms: "5",
    price: "1060",
    price_vs_Market: "-140",
    available_from: "12/21/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/341266",
  },
  {
    ll_id: "9bf2dc02-b106-4bc2-a0cb-989ebd820abc",
    ll_name: "My Dublin Space",
    ru_id: "294249",
    verified: "yes",
    city: "dublin",
    neigbourhood: "cabra, phibsborough and smithfield",
    ll_engagement: "medium",
    property_type: "room_shared",
    rooms: "8",
    price: "1062",
    price_vs_Market: "-138",
    available_from: "12/23/21",
    admin_fee_type: "fixed",
    admin_fee_value: "50",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/294249",
  },
  {
    ll_id: "34edf183-248a-44f6-bb68-12beefa5b430",
    ll_name: "Desmond Dempsey",
    ru_id: "234438",
    verified: "yes",
    city: "dublin",
    neigbourhood: "the liberties, inchicore and phoenix park",
    ll_engagement: "high",
    property_type: "room_shared",
    rooms: "3",
    price: "1100",
    price_vs_Market: "-100",
    available_from: "11/14/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/234438",
  },
  {
    ll_id: "34edf183-248a-44f6-bb68-12beefa5b430",
    ll_name: "Desmond Dempsey",
    ru_id: "234439",
    verified: "yes",
    city: "dublin",
    neigbourhood: "the liberties, inchicore and phoenix park",
    ll_engagement: "high",
    property_type: "room_shared",
    rooms: "3",
    price: "1100",
    price_vs_Market: "-100",
    available_from: "11/30/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/234439",
  },
  {
    ll_id: "6496d212-dcd8-400d-a0be-4a7887dd1213",
    ll_name: "Roisin Gaffney",
    ru_id: "218377",
    verified: "yes",
    city: "dublin",
    neigbourhood: "clontarf, east wall and fairview",
    ll_engagement: "high",
    property_type: "room_shared",
    rooms: "1",
    price: "760",
    price_vs_Market: "-40",
    available_from: "12/6/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/218377",
  },
  {
    ll_id: "bb2dae7e-862e-4646-b1e2-fa03807db366",
    ll_name: "Mircea Ionita",
    ru_id: "393276",
    verified: "yes",
    city: "dublin",
    neigbourhood: "donnybrook, irishtown and sandymount",
    ll_engagement: "medium",
    property_type: "room_shared",
    rooms: "2",
    price: "1000",
    price_vs_Market: "-30",
    available_from: "12/18/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/393276",
  },
  {
    ll_id: "28cdba6e-1039-4f6b-a0b2-835cdf494b82",
    ll_name: "Robert McGrath",
    ru_id: "595714",
    verified: "yes",
    city: "dublin",
    neigbourhood: "churchtown, clonskeagh and dundrum",
    ll_engagement: "high",
    property_type: "room_shared",
    rooms: "4",
    price: "800",
    price_vs_Market: "-10",
    available_from: "11/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/595714",
  },
  {
    ll_id: "ad663b14-989c-4fa8-9d0b-2f93fc56bfdf",
    ll_name: "Annette McGuinness",
    ru_id: "141313",
    verified: "yes",
    city: "dublin",
    neigbourhood: "blanchardstown, castleknock and clonsilla",
    ll_engagement: "high",
    property_type: "studio",
    rooms: "0",
    price: "1000",
    price_vs_Market: "0",
    available_from: "10/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/141313",
  },
  {
    ll_id: "b2cd2093-c1a9-4be7-b197-0c05503928a3",
    ll_name: "Sharon O'Hara",
    ru_id: "118891",
    verified: "yes",
    city: "dublin",
    neigbourhood: "artane, coolock and raheny",
    ll_engagement: "high",
    property_type: "room_shared",
    rooms: "5",
    price: "800",
    price_vs_Market: "0",
    available_from: "11/9/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/118891",
  },
  {
    ll_id: "b2cd2093-c1a9-4be7-b197-0c05503928a3",
    ll_name: "Sharon O'Hara",
    ru_id: "118805",
    verified: "yes",
    city: "dublin",
    neigbourhood: "artane, coolock and raheny",
    ll_engagement: "high",
    property_type: "room_shared",
    rooms: "5",
    price: "800",
    price_vs_Market: "0",
    available_from: "10/11/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/118805",
  },
  {
    ll_id: "e91a6f49-4885-4510-a026-34c94999e33c",
    ll_name: "Siobhan Mullins",
    ru_id: "116643",
    verified: "yes",
    city: "dublin",
    neigbourhood: "donaghmede, sutton and howth ",
    ll_engagement: "high",
    property_type: "room_shared",
    rooms: "2",
    price: "750",
    price_vs_Market: "0",
    available_from: "12/24/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/116643",
  },
  {
    ll_id: "de81c7d6-f5d9-4646-a352-91ed99c871eb",
    ll_name: "Geraldine Oleary",
    ru_id: "255110",
    verified: "yes",
    city: "dublin",
    neigbourhood: "clondalkin, rowlagh and liffey valley",
    ll_engagement: "high",
    property_type: "room_shared",
    rooms: "4",
    price: "650",
    price_vs_Market: "0",
    available_from: "10/12/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/255110",
  },
  {
    ll_id: "dfea3071-4499-4446-a097-da4cf9468f8b",
    ll_name: "Rita Boylan",
    ru_id: "115956",
    verified: "yes",
    city: "dublin",
    neigbourhood: "artane, coolock and raheny",
    ll_engagement: "high",
    property_type: "room_shared",
    rooms: "4",
    price: "650",
    price_vs_Market: "0",
    available_from: "12/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/115956",
  },
  {
    ll_id: "1e954b3a-6fe1-44a8-b11f-7bd4321159c4",
    ll_name: "Deirdre Kelly",
    ru_id: "264855",
    verified: "yes",
    city: "dublin",
    neigbourhood: "artane, coolock and raheny",
    ll_engagement: "high",
    property_type: "room_shared",
    rooms: "3",
    price: "650",
    price_vs_Market: "0",
    available_from: "12/18/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/264855",
  },
  {
    ll_id: "e3fa9380-473b-4831-aaea-5e3398d42c14",
    ll_name: "Rita Mcloughlin",
    ru_id: "252603",
    verified: "yes",
    city: "dublin",
    neigbourhood: "blanchardstown, castleknock and clonsilla",
    ll_engagement: "medium",
    property_type: "room_shared",
    rooms: "4",
    price: "600",
    price_vs_Market: "0",
    available_from: "11/1/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/252603",
  },
  {
    ll_id: "166fb5fa-98b4-4f0c-b588-15579c751d0a",
    ll_name: "Dee Byrne",
    ru_id: "408419",
    verified: "yes",
    city: "dublin",
    neigbourhood: "ballinteer, ballyboden and knocklyon ",
    ll_engagement: "high",
    property_type: "room_shared",
    rooms: "4",
    price: "800",
    price_vs_Market: "30",
    available_from: "11/18/21",
    admin_fee_type: "noAdminFee",
    admin_fee_value: "0",
    link: "http://www.spotahome.com/dublin/for-rent:apartments/408419",
  },
];
